import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticsService {
  /**
   * Local diagnostic logger kept for existing recording and room diagnostics.
   * This service only writes local diagnostic output.
   */
  logMessage(message: string, level: 'info' | 'warning' | 'error' | 'debug' = 'info', extra?: any): void {
    if (environment.production) {
      return;
    }

    const normalizedLevel = level === 'warning' ? 'warn' : level;
    const logger = console[normalizedLevel] || console.log;
    logger(`[${level.toUpperCase()}]`, message, extra || '');
  }

  /**
   * Track session record locally.
   */
  trackSessionRecord(sessionId: string, userId: string, recordingData?: any): void {
    if (environment.production) {
      return;
    }

    console.log('[TRACK SESSION RECORD]', {
      sessionId,
      userId,
      timestamp: new Date().toISOString(),
      ...recordingData
    });
  }

  /**
   * Track important events locally.
   */
  trackEvent(eventType: string, message: string, eventData?: any): void {
    if (environment.production) {
      return;
    }

    console.log(`🎯 [TRACK EVENT] ${eventType}: ${message}`, eventData || '');
  }

  /**
   * Log an error locally.
   */
  logError(message: string, error?: any, extra?: any): void {
    if (environment.production) {
      return;
    }

    console.error(message, error, extra || '');
  }

  /**
   * Compatibility no-op for previous telemetry callers.
   */
  setUser(userId: string, userData?: any): void {
  }

  /**
   * Compatibility no-op for previous telemetry callers.
   */
  setTag(key: string, value: string): void {
  }

  /**
   * Compatibility no-op for previous telemetry callers.
   */
  setContext(key: string, context: any): void {
  }
}
